import { __assign } from "tslib";
import React, { useEffect, useState } from 'react';
import Checkbox from '../UI/Checkbox/Checkbox';
/**
 * Renders the consents component from config
 * @params {(value: boolean) => void} [isValid] - function validation for required fields with callback true or false
 *
 * @example
 * <Consents />
 */
var Consents = function (_a) {
    var isValid = _a.isValid;
    var _b = useState([]), consents = _b[0], setConsents = _b[1];
    var required = useState([])[0];
    var _c = useState({}), values = _c[0], setValues = _c[1];
    useEffect(function () {
        var consentsData = globalThis.A6YReactAuthConfig &&
            globalThis.A6YReactAuthConfig.components &&
            globalThis.A6YReactAuthConfig.components.consents;
        if (Array.isArray(consentsData)) {
            setConsents(consentsData);
        }
    }, []);
    useEffect(function () {
        var validation = [];
        var valuesKeys = Object.keys(values);
        required.map(function (value) {
            if (valuesKeys.includes(value) && !values[value]) {
                validation.push(value);
            }
            else if (!valuesKeys.includes(value)) {
                validation.push(value);
            }
        });
        if (isValid)
            isValid(validation.length > 0 ? false : true);
    }, [values]);
    function getLabel(content) {
        var linkRgx = /\(.*?\)\[.*?\]/;
        var matchRgx = /\((.*?)\)\[(.*?)\]/;
        var arrayOfContent = content.split(' ');
        return (React.createElement(React.Fragment, null, arrayOfContent.map(function (el) {
            if (linkRgx.test(el)) {
                var match = el.match(matchRgx);
                return React.createElement("a", { href: match ? match[2] : '' }, match && match[1]);
            }
            else {
                return el + ' ';
            }
        })));
    }
    var renderConsentsElements = function () {
        var rendersElements = [];
        consents.map(function (consent, idx) {
            if (consent.type === 'checkbox') {
                if (consent.required) {
                    required.push("consent" + idx);
                }
                rendersElements.push(React.createElement(Checkbox, { id: "consent-" + idx, onChange: function (e) {
                        var _a;
                        return setValues(__assign(__assign({}, values), (_a = {}, _a["consent" + idx] = e.target.checked, _a)));
                    }, value: "" + values["consent" + idx] }, getLabel(consent.content)));
            }
            else {
                rendersElements.push(React.createElement("label", { className: "a6y-react-auth__checkbox-label--without-input" }, getLabel(consent.content)));
            }
        });
        return rendersElements;
    };
    return (React.createElement("div", { className: 'a6y-react-auth__consents' }, consents.length > 0 && renderConsentsElements()));
};
export default Consents;
//# sourceMappingURL=Consents.js.map